import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-anchor-left-icon',
  templateUrl: './design-anchor-left.component.html'
})
export class DesignAnchorLeftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
